// extracted by mini-css-extract-plugin
module.exports = {"Section3":"Section3_Section3__35WEg","content":"Section3_content__1S2XJ","button":"Section3_button__18ilL"};